import { FadeUp } from "./motion";

export function Container({ children, className = "" }) {
  return <div className={`max-w-7xl mx-auto px-6 sm:px-8 ${className}`}>{children}</div>;
}

export function SectionHeading({ index, eyebrow, title, copy, dark = false, className = "" }) {
  return (
    <div className={`max-w-3xl ${className}`}>
      <FadeUp>
        <p className={`eyebrow flex items-center gap-3 ${dark ? "text-sage" : "text-forest-700"}`} data-testid={`section-eyebrow-${index}`}>
          {index && <span className={`font-mono text-[11px] ${dark ? "text-sage/70" : "text-forest-700/60"}`}>{index}</span>}
          {index && <span className={`h-px w-8 ${dark ? "bg-sage/40" : "bg-forest-700/30"}`} />}
          {eyebrow}
        </p>
      </FadeUp>
      <FadeUp delay={0.08}>
        <h2 className={`mt-5 font-serif text-4xl sm:text-5xl font-medium leading-[1.08] ${dark ? "text-cream" : "text-forest"}`}>
          {title}
        </h2>
      </FadeUp>
      {copy && (
        <FadeUp delay={0.16}>
          <p className={`mt-6 text-base sm:text-lg leading-relaxed ${dark ? "text-cream/70" : "text-charcoal/70"}`}>{copy}</p>
        </FadeUp>
      )}
    </div>
  );
}
